<template>
  <div class="mobile_service">
    <TopInside theme_="light"></TopInside>

    <img
      class="mobile_inside"
      src="../../../static/mobile/brief_0.jpg"
      alt=""
    />
    <div :class="['mobile_menu_con']">
      <div class="mobile_menu">
        <div
          @click="menuActive(item, i)"
          class="mobile_menu_item"
          v-for="(item, i) in menu"
          :key="i"
        >
          {{ item.name }}
        </div>
        <div class="line" :style="{ left: left }"></div>
      </div>
    </div>
    <div class="mobile_service_con">
      <p class="mobile_service_title">{{ title }}</p>
      <div class="service_item" v-for="(item, i) in list" :key="i">
        <div class="title">{{ item.title }}</div>
        <el-input
          v-if="item.valueName != 'code'"
          style="width: 90%; margin-bottom: 1rem"
          v-model="dataForm[item.valueName]"
          :type="item.type"
          :placeholder="item.placeholder"
          :maxlength="item.maxInput"
        ></el-input>
        <el-input
          v-else
          style="width: 90%; margin-bottom: 1rem"
          v-model="dataForm[item.valueName]"
          :placeholder="item.placeholder"
        >
          <template slot="append">
            <span v-show="show" @click="getCode">获取验证码</span>
            <span v-show="!show">{{ count }}秒重发</span>
          </template>
        </el-input>
      </div>
      <div v-if="title == '保函查验'" class="tips">*仅可查验本平台保单</div>
      <div v-if="title == '理赔申请'" class="tips">*仅可申请理赔本平台保单</div>
    </div>
    <div class="btn" @click="submit">提交</div>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '300px', height: '187px' }"
    />

    <mt-popup v-model="popupVisible" position="right">
      <div class="confirm_con">
        <div class="confirm_title">查验详情</div>
        <div class="confirm_title_text">投保方名称:</div>
        <p class="confirm_title_detail">{{ dialogForm.applicantName }}</p>
        <div class="confirm_title_text">机构代码：</div>
        <p class="confirm_title_detail">{{ dialogForm.applicantCode }}</p>
        <div class="confirm_title_text">出函机构：</div>
        <img class="confirm_title_img" :src=" dialogForm.insurCompanyLogoUrl" />
        <div class="confirm_title_text">投保时间：</div>
        <p class="confirm_title_detail">{{ dialogForm.orderIssuingTime }}</p>
        <div class="confirm_title_text">保单号：</div>
        <p class="confirm_title_detail">{{ dialogForm.policyNo }}</p>

      </div>
    </mt-popup>
  </div>
</template>

<script>
import TopInside from "./TopInside.vue";
import { Toast, MessageBox } from "mint-ui";
import { Indicator } from "mint-ui";
import { validatePhone, validateTelephone } from "@/utils/validate";
import Verify from "@/components/verifition/Verify.vue";
import {
  claimApply,
  queryGuarantee,
  sendCheckCode,
  useCheckCode,
  saveBusCooperatio,
} from "../../api/basic/index.js";
export default {
  name: "",
  mixins: [],
  components: {
    TopInside,
    Verify,
  },
  provide() {
    return {
      sendCheckCodeWithSlider: this.sendCheckCodeWithSlider
    };
  },
  data() {
    return {
      popupVisible: false,
      menu: [
        { name: "商务合作", i: "0" },
        { name: "保函查验", i: "1" },
        { name: "理赔申请", i: "2" },
      ],
      list: [],
      list_1: [
        {
          title: "所在地：",
          valueName: "cooperationArea",
          placeholder: "请输入所在区域或城市",
          type: "text",
          maxInput: "100",
        },
        {
          title: "手机号码：",
          valueName: "phoneNumber",
          placeholder: "请输入手机号码",
          type: "number",
          maxInput: "11",
        },
        {
          title: "验证码：",
          valueName: "code",
          placeholder: "请输入验证码",
          type: "text",
          maxInput: "100",
        },
      ],
      list_2: [
        {
          title: "保函编号：",
          valueName: "policyNo",
          placeholder: "请输入保函编号",
          type: "text",
          maxInput: "100",
        },
        {
          title: "手机号码：",
          valueName: "phoneNumber",
          placeholder: "请输入手机号码",
          type: "number",
          maxInput: "11",
        },
        {
          title: "验证码：",
          valueName: "code",
          placeholder: "请输入验证码",
          type: "text",
          maxInput: "100",
        },
      ],
      list_3: [
        {
          title: "保函编号：",
          valueName: "policyNo",
          placeholder: "请输入保函编号",
          type: "text",
          maxInput: "100",
        },
        {
          title: "理赔原因：",
          valueName: "claimReason",
          placeholder: "请输入理赔原因",
          type: "textarea",
          maxInput: "50",
        },
        {
          title: "手机号码：",
          valueName: "phoneNumber",
          placeholder: "请输入手机号码",
          type: "number",
          maxInput: "11",
        },
        {
          title: "验证码：",
          valueName: "code",
          placeholder: "请输入验证码",
          type: "text",
          maxInput: "100",
        },
      ],
      title: "",
      params: {
        cooperationArea: "",
        phoneNumber: "",
        policyNo: "",
        businessType: "",
      },
      dataForm: {
        // cooperationArea: "",
        // phoneNumber: "",
        // claimReason: "",
        // code: "",
      },
      show: true,
      timer: null,
      count: "获取验证码",
      left: 0,
      dialogForm:{}
    };
  },
  computed: {},
  watch: {},
  created() {
    this.title = "商务合作";
    this.list = this.list_1;
  },
  mounted() {},
  methods: {
    menuActive(item, i) {
      this.left = item.i * 33 + "%";
      this.title = item.name;
      this.list = this["list_" + (i + 1)];
      this.clear();
    },

    submit() {
     
      let obj = this.dataForm;
      console.log(obj);
      //    if( Object.keys(obj).length === 0){
      //     return Toast('请填写完整信息')
      //    };

      //    for(let k in obj) {
      //     console.log(k)
      //     if(!obj[k]){
      //         Toast('请填写完整信息');
      //     }else if(k == 'phoneNumber'&&obj[k].length!= 11){
      //         Toast('手机号格式不正确');
      //     }else{

      //     }
      //    }
      if (this.title == "商务合作" || this.title == "保函查验") {
        if (Object.keys(obj).length < 3) {
          return Toast("请填写完整信息");
        }
      } else if (this.title == "理赔申请") {
        if (Object.keys(obj).length < 4) {
          return Toast("请填写完整信息");
        }
      }
      if (obj.phoneNumber.length != 11) {
        return Toast("请输入正确的联系电话");
      }
      Indicator.open();
      this.getCodeCheckResult(obj);
    },
    getCodeCheckResult(obj) {
      const phoneParams = {
        phone: obj.phoneNumber,
        businessCode: "globalTemplate",
        checkCode: obj.code,
      };
      useCheckCode(phoneParams).then((phoneRes) => {
        Indicator.close();
        if (phoneRes.data.resultCode == "200") {
          this.sendParams(this.title);
        }
      });
    },
    sendParams(title) {
      switch (title) {
        case "商务合作":
          this.saveBusCooperatio();
          break;
        case "保函查验":
          this.queryGuarantee();
          break;
        case "理赔申请":
          this.claimApply();
          break;
      }
    },
    saveBusCooperatio() {
      // 商务合作
      let obj = this.dataForm;
      let params = this.params;
      params.phoneNumber = obj.phoneNumber;
      params.cooperationArea = obj.cooperationArea;
      params.businessType = 1;
      Indicator.open();
      saveBusCooperatio(params).then((res) => {
        Indicator.close();
        if (res.data.resultCode == "200") {
          this.clear();
          Toast("提交成功！稍后会有客服人员联系您。");
          this.dialogFormVisible = false;
        }
      });
    },
    queryGuarantee() {
      // 保函查验
      let obj = this.dataForm;
      let params = this.params;
      params.phoneNumber = obj.phoneNumber;
      params.policyNo = obj.policyNo;
      params.businessType = 2;
      Indicator.open();
      queryGuarantee(params).then((res) => {
        Indicator.close();
        if (res.data.resultCode == "200") {
          this.clear();
          if (res.data.data) {
            MessageBox.alert('保单'+obj.policyNo+'查验成功！','提示',{
              confirmButtonText:'查看该保函详情'
            }).then(action => {
              console.log('action',action)
              this.dialogForm = res.data.data;
              this.popupVisible = true;
            })
          } else {
            Toast("此保单平台不存在");
          }
        }
      });
    },
    claimApply() {
      // 理赔申请
      let obj = this.dataForm;
      let params = this.params;
      params.phoneNumber = obj.phoneNumber;
      params.policyNo = obj.policyNo;
      params.claimReason = obj.claimReason;
      params.businessType = 3;
      Indicator.open();
      claimApply(params).then((res) => {
        Indicator.close();
        if (res.data.resultCode == "200") {
          this.clear();
          if (res.data.data) {
            MessageBox.alert('已经收到您的理赔申请，稍后会有客服人员联系您具体理赔事宜，如有其他问题可以拨打客服电话：400-6399580','申请提交成功',{
              confirmButtonText:'确认'
            }).then(action => {
          
            })
          } else {
            this.$alert("此保单平台不存在", "申请提交失败", {
              confirmButtonText: "确定",
            });
            MessageBox.alert('此保单平台不存在。','申请提交失败',{
              confirmButtonText:'确认'
            }).then(action => {
          
            })
          }
        }
      });
    },
    getCode() {
      console.log("this.dataForm.phoneNumber", this.dataForm.phoneNumber);
      if (!this.dataForm.phoneNumber) {
        Toast("请先输入手机号");
        return;
      }
      if (
        (!validatePhone(this.dataForm.phoneNumber) &&
          !validateTelephone(this.dataForm.phoneNumber)) ||
        this.dataForm.phoneNumber.length != 11
      ) {
        Toast("请输入正确的联系电话");
      } else {
        //查询是否进行行为认证
        this.$refs.verify.show();
      }
    },
    // 发送验证码带滑块
    async sendCheckCodeWithSlider(sliderParams) {
      this.getVerifyCode();
      const params = {
        phone: this.dataForm.phoneNumber,
        businessCode: "globalTemplate",
        graphicData:sliderParams,
      }
      try{
        await sendCheckCode(params)
        this.$message.success({
          title: '提示',
          message: '短信发送成功，请注意查收',
          type: 'success',
        });
        return true
      }catch (e){
        return false
      }
    },
    getVerifyCode() {
      this.show = false;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    clear() {
      this.dataForm = {};
      this.params = {
        cooperationArea: "",
        phoneNumber: "",
        policyNo: "",
        businessType: "",
      };
      this.show = true;
      this.timer = null;
      this.count = "获取验证码";
    },
  },
};
</script>

<style scoped >
.mobile_service {
  width: 100%;
  min-height: 100vh;
  /* background: #fefefe; */
  /* background: #A0C8E5; */
  /* background: #C9DCE8; */
  background: #f5f5f5;
  overflow-x: hidden;
  color: #5f6464;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mobile_menu_con {
  width: 100%;
  position: relative;
  height: 2.3rem;
  background: red;
}
.mobile_menu {
  width: 100%;
  display: flex;
  font-size: 0.8rem;
  height: 2.3rem;
  background: rgb(227, 227, 227);
  position: absolute;
  top: 0;
  left: 0;
}
.mobile_menu_item {
  height: 100%;
  flex-grow: 1;
  text-align: center;
  line-height: 2rem;
}
.line {
  background: #0052d9;
  width: 33.33%;
  height: 2px;
  position: absolute;
  left: 0;
  bottom: 0;
  transition: 0.2s ease-out;
}
.mobile_service_con {
  width: 20.73rem;
  background: #fefefe;
  border-radius: 0.7rem;
  margin: 2rem 0;
}
.title {
  width: 95%;
  text-align: left;
  margin: 1rem 0 1.1rem 0;
  color: #2069b7;
}
.mobile_service_title {
  font-size: 1.25rem;
  font-style: italic;
  color: #2a2e2e;
  width: 100%;
  text-align: center;
  margin: 1rem 0 3rem 0;
  color: #2062a8;
}
.service_item {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
/deep/.el-input-group__append {
  border-left: 0;
}
.btn {
  width: 20.73rem;
  border-radius: 1.3125rem;
  height: 2.85rem;
  background: #fff;
  line-height: 2.85rem;
  text-align: center;
  letter-spacing: 0.6rem;
  font-size: 1.3rem;
  margin-bottom: 5rem;
  color: #fff;
  font-weight: 600;
  /* background: #3c6bbb; */
  background: linear-gradient(#85a1d0, #3c6bbb);
}
.menu_service_fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1998;
}
.confirm_con {
  width: 18rem;
  height: 100vh;
  background: #fff;
  padding-left: 1rem;
  box-sizing: border-box;
}
.tips {
  font-size: 0.75rem;
  color: rgb(244, 85, 85);
  margin: 1rem 0 1rem 1rem;
}

.confirm_title {
  width: 95%;
  text-align: left;
  margin: 3rem 0.5rem 1.1rem 0.5rem;
  color: #2069b7;
  font-size: 1.2rem;
}
.confirm_title_text{
  width: 95%;
  text-align: left;
  margin: 2.3rem 0.5rem 1.1rem 0.2rem;
  color: #181818;
  font-size: 1rem;
}
.confirm_title_detail{
  width: 15rem;
  word-wrap:break-word;
  text-align: left;
  color: #4b4b4b;
  font-size: 1rem;
  margin: 0 0.5rem 0 0.8rem;
}
.confirm_title_img{
  width: 7rem;
  height: 2.3rem;
}
.mobile_inside {
  width: 100%;
}
</style>
